<template>
	<overlay-scrollbars class="page page-chat" ref="os">
		<div class="row main-block">
			<div class="col col-3 contacts">
				<div class="actions">
					<a @click="addChatParticipants" href="#" class="btn add-chat-btn">
						<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M7.66732 14.0002C11.1651 14.0002 14.0007 11.1646 14.0007 7.66683C14.0007 4.16903 11.1651 1.3335 7.66732 1.3335C4.16951 1.3335 1.33398 4.16903 1.33398 7.66683C1.33398 11.1646 4.16951 14.0002 7.66732 14.0002Z" stroke="#EEF8FF" stroke-linecap="round" stroke-linejoin="round"/>
							<path d="M14.6673 14.6668L13.334 13.3335" stroke="#EEF8FF" stroke-linecap="round" stroke-linejoin="round"/>
						</svg>
					</a>
					<div @click="editChatSettings"><VerticalDots v-if="roomSettingsAccess" class="menu-settings-img img"/></div>
				</div>
				<overlay-scrollbars style="height: 100%;">
					<div @click="selectRoom(room.id)" v-for="(room, index) in rooms" :key="index" class="room-item">
						<div v-if="room.type == 1" class="chat" :class="{ 'room-active': room.active }">
							<div class="img">
								<img :src="room.interlocutor.logo" />
							</div>
							<div class="chat-content">
								<div class="chat-name">{{ room.interlocutor.name ? room.interlocutor.name : room.interlocutor.email }}</div>
								<div class="chat-subinfo">
									<span v-if="room.unread_messages" class="puls-btn chat-subinfo-count">{{ room.unread_messages }}</span>
								</div>
							</div>
						</div>
						<div v-else class="chat" :class="{ 'room-active': room.active }">
							<div class="chat-content">
								<div class="chat-name public-chat-name" :class="{ 'room-has-name': room.hasName }">{{ room.name ? room.name : room.email }}</div>
								<div class="chat-subinfo">
									<span v-if="room.unread_messages" class="puls-btn chat-subinfo-count">{{ room.unread_messages }}</span>
								</div>
							</div>
						</div>
					</div>
				</overlay-scrollbars>
			</div>
			<div class="col col-9 ">
				<div v-if="activeRoom && activeRoom.apply_offer" class="apply-offer-wrapper row">
					<div class="col-6 offer-main-info">
						<span v-if="!activeRoom.offerable_id">
							<a v-if="roomSettingsAccess" href="#" @click="selectOfferUser" class="btn select-offer-desc-btn">Select offer</a>
						</span>
						<div v-else-if="activeRoom.offerable">
							<div v-if="activeRoom.offerable_type == 'App\\Models\\Offer'">
								<div>{{ activeRoom.offerable.financial_institution_name }}</div>
								<div>{{ activeRoom.offerable.country_code }}</div>
							</div>
							<div v-else-if="activeRoom.offerable_type == 'App\\Models\\LegalService'">
								<div>{{ activeRoom.offerable.services_type }}</div>
								<div>{{ activeRoom.offerable.country ? activeRoom.offerable.country.code : '' }}</div>
							</div>
							<div v-else-if="activeRoom.offerable_type == 'App\\Models\\BusinessOffer'">
								<div>{{ activeRoom.offerable.business_type }}</div>
								<div>{{ activeRoom.offerable.country ? activeRoom.offerable.country.code : '' }}</div>
							</div>
							<div v-else-if="activeRoom.offerable_type == 'App\\Models\\SoftwareAddService'">
								<div>{{ activeRoom.offerable.service_name }}</div>
								<div>{{ activeRoom.offerable.country ? activeRoom.offerable.country.code : '' }}</div>
							</div>
						</div>
						<a v-if="roomSettingsAccess && activeRoom.offerable_id" href="#" @click="selectOfferUser" class="btn edit-offer-btn"><Pen class="img"/></a>
					</div>
					<div class="col-6">
						<div v-if="roomSettingsAccess && offerShowProgressForm">
							<div class="offer-desc-input percent-offer-desc-input"><input class="form-control" min="0" max="100" v-model="offerProgress" type="number" placeholder="Enter progress" /></div>
							<div class="offer-desc-input"><input class="form-control" v-model="offerProgressDescription" type="description" placeholder="Enter description" /></div>
							<div class="offer-desc-input">
								<a href="#" @click="saveOfferDescription" class="btn save-offer-desc-btn">Save</a>
							</div>
						</div>
						<div v-else class="offer-progress-info">
							<div>{{ activeRoom.offer_progress }}<span v-if="activeRoom.offer_progress">%</span></div>
							<div>{{ activeRoom.offer_progress_description }}</div>
							<div v-if="roomSettingsAccess">
								<a href="#" @click="offerShowProgressForm = true" class="btn edit-offer-desc-btn"><Pen class="img"/></a>
							</div>
						</div>
					</div>
				</div>
				<overlay-scrollbars :style="{'height': activeRoom && activeRoom.apply_offer ? '70%' : '100%'}" ref="chatMessagesScrolls">
					<div v-if="rooms.length == 0" class="no-messages">
					</div>
					<div v-else>
						<div class="messages">
							<div v-if="activeRoom" :class="{ 'user-message' : isUserMessage(message) }" class="message" v-for="(message, index) in activeRoom.messages" :key="index">
								<div v-if="message.user_id != user.id" class="img">
									<img v-if="message.user.logo" :src="thumbsUrl +  message.user.logo" />
									<img v-else src="/img/default-avatar.png" />
								</div> 
								<div class="message-content">
									<div v-if="activeRoom.type == 2" class="message-user-login">{{ getUserMessageLogin(message) }}</div>
									<div v-if="message.user_id != user.id" class="chat-role">{{ getRole(message) }}</div>
									<div class="message-text pre-formatted">{{ message.message_text }}</div>
									<div class="message-text" v-for="(doc, id) in message.documents" :key="id">
										<a class="document-link" target="_blank" v-if="doc.ready || !doc.loading" :href="backendUrl + 'storage/chat/documents/' + doc.file">{{ doc.original_name }}</a>
										<div v-else>{{ doc.original_name }}</div>
										<k-progress 
										  v-if="doc.loading"
									      status="success" 
									      type="line"
									      :percent="doc.loadingPercent"
									      :color="['#05737A']"
									      :show-text="false"
									       >
									    </k-progress>
									</div>
									<div class="message-date">{{ message.created_at | moment("Y-MM-DD HH:mm") }}</div>
								</div>
							</div>
						</div>
					</div>
				</overlay-scrollbars>
			</div>
		</div>
		<div class="row ttl send-actions">
			<input @change="onFilesChange" ref="filesInput"  accept=".gif,.jpg,.jpeg,.png,.doc,.docx,.pdf" class="files-input" type="file" name="filefield" multiple="multiple">
			<textarea v-model="message" rows="4" name="message" type="text" placeholder="" class="form-control main-message" />
			<a @click="openFilesSelection" href="#" class="btn upload-btn">
				<svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" clip-rule="evenodd" d="M14.1722 2.79824C15.5692 1.84924 17.3355 1.83066 18.6477 2.69245C18.9457 2.88813 19.2638 3.19871 20.1145 4.04943C20.9653 4.90013 21.2759 5.21835 21.4715 5.51633C22.3334 6.82857 22.3148 8.59485 21.3658 9.9918C21.1491 10.3106 20.8139 10.6524 19.932 11.5343L18.6541 12.8122C18.2509 13.2155 18.2509 13.8694 18.6541 14.2727C19.0575 14.676 19.7114 14.676 20.1145 14.2727L21.3924 12.9948L21.4812 12.9061C22.2446 12.1429 22.7331 11.6545 23.0743 11.1524C24.4688 9.09945 24.5409 6.4274 23.198 4.38256C22.8704 3.88384 22.3931 3.40671 21.6673 2.68113L21.575 2.58895L21.4829 2.49671C20.7573 1.77088 20.2802 1.29354 19.7814 0.966031C17.7366 -0.376882 15.0646 -0.304882 13.0116 1.08975C12.5095 1.43083 12.0211 1.91941 11.2578 2.68287L11.1692 2.77151L9.8913 4.04943C9.48799 4.45272 9.48799 5.10659 9.8913 5.50989C10.2946 5.91318 10.9485 5.91318 11.3518 5.50989L12.6297 4.23197C13.5116 3.35004 13.8534 3.01482 14.1722 2.79824ZM5.50989 11.3518C5.91319 10.9485 5.91319 10.2946 5.50989 9.89129C5.10658 9.488 4.45271 9.488 4.04942 9.89129L2.7715 11.1692L2.68288 11.2578C1.9194 12.0211 1.43084 12.5095 1.08974 13.0116C-0.304892 15.0646 -0.376872 17.7366 0.966041 19.7815C1.29355 20.2801 1.77087 20.7572 2.49674 21.4828L2.58894 21.5751L2.68112 21.6672C3.4067 22.393 3.88383 22.8706 4.38255 23.1979C6.42741 24.5409 9.09944 24.469 11.1524 23.0742C11.6545 22.7332 12.1429 22.2445 12.9062 21.4811L12.9948 21.3925L14.2727 20.1147C14.676 19.7113 14.676 19.0574 14.2727 18.6542C13.8694 18.2508 13.2155 18.2508 12.8122 18.6542L11.5343 19.9321C10.6524 20.814 10.3106 21.1492 9.99181 21.3657C8.59484 22.3148 6.82858 22.3333 5.51632 21.4717C5.21836 21.2758 4.90014 20.9652 4.04942 20.1147C3.19869 19.2639 2.88814 18.9456 2.69244 18.6476C1.83067 17.3354 1.84925 15.5692 2.79823 14.1722C3.01481 13.8534 3.35005 13.5116 4.23198 12.6297L5.50989 11.3518ZM16.4644 9.16007C16.8677 8.75678 16.8677 8.10289 16.4644 7.6996C16.0611 7.29631 15.4072 7.29631 15.0039 7.6996L7.70155 15.002C7.29826 15.4053 7.29826 16.0591 7.70155 16.4624C8.10484 16.8657 8.75871 16.8657 9.16203 16.4624L16.4644 9.16007Z" fill="#fff"/>
				</svg>
			</a>
			<a @click="sendMessage" href="#" class="btn send-btn">
				<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.40995 21.7501C4.28995 21.7501 3.57995 21.3701 3.12995 20.9201C2.24995 20.0401 1.62995 18.1701 3.60995 14.2001L4.47995 12.4701C4.58995 12.2401 4.58995 11.7601 4.47995 11.5301L3.60995 9.80014C1.61995 5.83014 2.24995 3.95014 3.12995 3.08014C3.99995 2.20014 5.87995 1.57014 9.83995 3.56014L18.3999 7.84014C20.5299 8.90014 21.6999 10.3801 21.6999 12.0001C21.6999 13.6201 20.5299 15.1001 18.4099 16.1601L9.84995 20.4401C7.90995 21.4101 6.46995 21.7501 5.40995 21.7501ZM5.40995 3.75014C4.86995 3.75014 4.44995 3.88014 4.18995 4.14014C3.45995 4.86014 3.74995 6.73014 4.94995 9.12014L5.81995 10.8601C6.13995 11.5101 6.13995 12.4901 5.81995 13.1401L4.94995 14.8701C3.74995 17.2701 3.45995 19.1301 4.18995 19.8501C4.90995 20.5801 6.77995 20.2901 9.17995 19.0901L17.7399 14.8101C19.3099 14.0301 20.1999 13.0001 20.1999 11.9901C20.1999 10.9801 19.2999 9.95014 17.7299 9.17014L9.16995 4.90014C7.64995 4.14014 6.33995 3.75014 5.40995 3.75014Z" fill="white"/>
					<path d="M10.8414 12.75H5.44141C5.03141 12.75 4.69141 12.41 4.69141 12C4.69141 11.59 5.03141 11.25 5.44141 11.25H10.8414C11.2514 11.25 11.5914 11.59 11.5914 12C11.5914 12.41 11.2514 12.75 10.8414 12.75Z" fill="white"/>
				</svg>
			</a>
		</div>
	</overlay-scrollbars>
</template>

<script>
import Vue from 'vue'
Vue.use(require('vue-moment'))
import { mapMutations, mapActions, mapGetters } from 'vuex';
import KProgress from 'k-progress';
Vue.component('k-progress', KProgress);
import VerticalDots from '@/components/img/VerticalDots.vue'
import Pen from '@/components/img/Pen.vue'

export default {
	components: {
		VerticalDots,
		Pen,
	},
	data () {
		return {
			message: null,
			rooms: [], 
			chats: [],
			activeRoom: null,
			chatMessages: [],
			backendUrl: process.env.VUE_APP_BACKEND_URL,
			chatParticipants: [],
			thumbsUrl: process.env.VUE_APP_BACKEND_URL + 'storage/images/users/logos/thumbs/',
			defaultPersonalManager: null,
			offerShowProgressForm: false,
			offerProgress: '',
			offerProgressDescription: ''
		}
	},
	methods: {
		...mapMutations({
	      setMessagesCount: 'SET_MESSAGES_COUNT',
	      updateChatsMethod: 'UPDATE_CHATS',
	      decrementMessageCount: 'DECREMENT_MESSAGE_COUNT'
	    }),
	    ...mapActions({
	      setCountMessagesRead: 'setCountMessagesRead',
	    }),
	    openFilesSelection () {
	    	this.$refs.filesInput.click()
	    },
	    editChatSettings () {
	    	const applyOffer = this.activeRoom.apply_offer
	    	this.$store.commit('setModal', {
		        template: 'chat-settings',
		        options: {
		          activeRoom: this.activeRoom,
		          applyOffer: applyOffer
		        }
		      })
	    },
	    onFilesChange (e) { 
	    	const files = e.target.files || e.dataTransfer.files;
			if (!files.length)
			    return
			const that = this
			axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/message', {
				message: '',
				room_id: this.activeRoom.id,
				with_documents: true,
			}) 
			.then(({ data }) => {
			  if (data.success && this.activeRoom) {
			  	this.sendFiles(files, data.message)
			  }
	          this.message = ''
	        })
	    },
	    sendFiles (files, message) {
	    	const docs = []
	    	for (let i = 0; i < files.length; i++) {
				docs.push({
					id: message.id,
					original_name: files[i].name,
					loading: true,
					loadingPercent: 0
				})
				files[i].id = message.id
			}
	    	message.documents = docs
	    	for (let i = 0; i < this.rooms.length; i++) {
				if (this.rooms[i].id == this.activeRoom.id) {
					this.rooms[i].messages.push(message)
				}
			} 
			files.forEach(file => {
				this.uploadFile(file, message)
			})
			const that = this
			setTimeout(function () {
				that.$refs.chatMessagesScrolls.osInstance().scroll({ y : "100%" }, 0)
			}, 700)
	    },
	    uploadFile (file, message) {
	    	const that = this
	    	const config = {
	    		headers: { "Content-Type": "multipart/form-data" },
			    onUploadProgress: function(progressEvent) {
			      var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
			      for (let i = 0; i < that.rooms.length; i++) {
						if (that.rooms[i].id == that.activeRoom.id) {
							for (let k = 0; k < that.rooms[i].messages.length; k++) {
								if (that.rooms[i].messages[k].id == file.id) {
									for (let n = 0; n < that.rooms[i].messages[k].documents.length; n++) {
										if (that.rooms[i].messages[k].documents[n].original_name == file.name) {
											that.rooms[i].messages[k].documents[n].loadingPercent = percentCompleted
										}
									}
								}
							}
						}
					}
			    }
			}
		    let data = new FormData()
		    data.append('file', file)
 
		    axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/document/' + message.id, data, config)
		        .then(({ data }) => {
				  if (data.success) {
				  	for (let i = 0; i < that.rooms.length; i++) {
						if (that.rooms[i].id == that.activeRoom.id) {
							for (let k = 0; k < that.rooms[i].messages.length; k++) {
								if (that.rooms[i].messages[k].id == message.id) {
									for (let n = 0; n < that.rooms[i].messages[k].documents.length; n++) {
										if (that.rooms[i].messages[k].documents[n].original_name == file.name) {
											that.rooms[i].messages[k].documents[n].loading = false
											that.rooms[i].messages[k].documents[n].ready = true
											that.rooms[i].messages[k].documents[n].file = data.document.file
										}
									}
								}
							}
						}
					}
				  }
		        })
		      .catch(err => console.log(err))
	    },
	    isUserMessage (message) {
	    	return message.user_id == this.user.id
	    },
	    getUserMessageLogin (message) {
	    	if (message.user_id != this.user.id) {
		    	return message.user.company_full_name
		    }
		    return ''
	    },
		sendMessage () {
			if (this.message && this.message.length > 1 && this.activeRoom) {
				axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/message', {
					message: this.message,
					room_id: this.activeRoom.id,
				}) 
				.then(({ data }) => {
				  if (data.success && this.activeRoom) {
				  	for (let i = 0; i < this.rooms.length; i++) {
				  		if (this.rooms[i].id == this.activeRoom.id) {
				  			this.rooms[i].messages.push(data.message)
				  		}
				  	}
				  }
		          this.message = ''
		          const that = this
				  setTimeout(function () {
					that.$refs.chatMessagesScrolls.osInstance().scroll({ y : "100%" }, 0)
				  }, 700)
		        })
		        .catch((error) => console.log(error))
			}
		},
		selectRoom (roomId) {
			const oldActiveRoom = this.activeRoom
			for (let i = 0; i < this.rooms.length; i++) {
				if (+this.rooms[i].id == +roomId) {	
					this.activeRoom = this.rooms[i]	
					const el = this.rooms[i]
					el.active = true
					this.offerProgress = el.offer_progress
					this.offerProgressDescription = el.offer_progress_description
					Vue.set(this.rooms, i, el)
				} else {
					const el = this.rooms[i]
					el.active = false
					Vue.set(this.rooms, i, el)
				}
			}  
			this.setRoomMessagesRead(roomId)
			const that = this
			setTimeout(function () {
				that.$refs.chatMessagesScrolls.osInstance().scroll({ y : "100%" }, 100)
			}, 2500)
			this.setCountRoomMessagesRead(this.activeRoom.id)
		},
		proccessServerRoom(room) {
			if (room.type == 1) {
        		const anotherUser = room.participants[0].user.id != this.user.id ? room.participants[0] : room.participants[1]
        		room.interlocutor = {
        			name: anotherUser.user.full_name ?? anotherUser.user.name,
					email: anotherUser.user.email,
        			logo: anotherUser.user.logo ? process.env.VUE_APP_BACKEND_URL + 'storage/images/users/logos/thumbs/' +  anotherUser.user.logo : '/img/default-avatar.png'
        		}
        	} else {
        		room.name = room.name ? room.name : room.public_name
        		room.hasName = room.name ? true : false
        	}
        	room.unread_messages = room.messages.length - room.user_read_statuses_count
        	room.active = false
			return room
		},
		getRooms() {
			const that = this
			this.rooms = []
			axios.get(process.env.VUE_APP_BACKEND_API_URL + 'chat/rooms').then(({data}) => {
	            for (let i = 0; i < data.length; i++) {
	            	data[i] = this.proccessServerRoom(data[i])
	            }
	            if (data[0]) {
	            	data[0].active = true
	            	data[0].unread_messages = 0
	                that.activeRoom = data[0]
	                that.setRoomMessagesRead(data[0].id)
	                that.offerProgress = data[0].offer_progress
					that.offerProgressDescription = data[0].offer_progress_description
	            }
	            this.rooms = data;
	            if (this.$route.params && this.$route.params.chatId) {
					this.selectRoom(this.$route.params.chatId)
		        }
	        }) 
		},
		setRoomMessagesRead(roomId) {
			for (let i = 0; i < this.rooms.length; i++) {
				if (this.rooms[i].id == roomId) {
					if (this.rooms[i].unread_messages) {
						this.decrementMessageCount(this.rooms[i].unread_messages)
					}
					this.rooms[i].unread_messages = 0
				}
			}
			axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/room-messages-read/' + roomId)
		      .then(({ data }) => {
		        if(data.success) {
		          //commit('SET_MESSAGES_COUNT', 0)
		        }
		      })
		      .catch((error) => console.log(error))
		},
		setCountRoomMessagesRead(roomId) {
			axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/count-room-messages-read/' + roomId)
		      .then(({ data }) => {
		        if(data.success) {
		          //commit('SET_MESSAGES_COUNT', 0)
		        }
		      })
		      .catch((error) => console.log(error))
		},
		addChatParticipants() {
			this.$store.commit('setModal', {
		        template: 'select-chat-participants',
		        options: {
		          participants: this.chatParticipants
		        }
		      })
		},
		getChatParticipants () {
			axios.get(process.env.VUE_APP_BACKEND_API_URL + 'chat/participants')
		      .then(({ data }) => {
		          this.chatParticipants = data
		      })
		      .catch((error) => console.log(error))
		},
		getPersonalMagager() {
			axios.get(process.env.VUE_APP_BACKEND_API_URL + 'chat/default-personal-manager')
		      .then(({ data }) => {
		          this.defaultPersonalManager = data
		      })
		      .catch((error) => console.log(error))
		},
		saveOfferDescription () {
			axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/offer-progress/' + this.activeRoom.id, {
				offer_progress: this.offerProgress,
				offer_progress_description: this.offerProgressDescription,
			}) 
		      .then(({ data }) => {
		      	  for (let i = 0; i < this.rooms.length; i++) {
						if (this.rooms[i].id == this.activeRoom.id) {
							this.rooms[i].offer_progress = data.offer_progress
							this.rooms[i].offer_progress_description = data.offer_progress_description
						}
					} 
		          this.offerShowProgressForm = false
		      })
		      .catch((error) => console.log(error))
		},
		selectOfferUser() {
			if (this.activeRoom) {
				this.$store.commit('setModal', {
			        template: 'select-chat-offer-user',
			        options: {
			          participants: this.activeRoom.participants
			        }
		      })
			}
		},
		getRole(message) {
			if (message.user && message.user.usertype == 'admin') {
				return 'admin'
			} else if (message.user && message.user.is_provider == 1) {
				return 'provider'
			}
			return 'user'
		}
	},
	created() {
		this.getRooms()
		this.getChatParticipants()
		this.setCountMessagesRead()
		this.getPersonalMagager()
    },
    computed: {  
    	...mapGetters({
	      newMessage: 'getNewMessage',
	      newChatRoom: 'getNewChatRoom',
	      chatRoomApplyOfferObj: 'getChatRoomApplyOfferObj',
	      offerUser: 'getChatOfferUser',
	      chatOffer: 'getChatOffer',
	    }),
	    user () {
	      return this.$store.state.user
	    },
	    roomSettingsAccess () {
	    	let hasAccess = false
	    	const user = this.$store.state.user
	    	if (user) {
	    		if (user.is_admin) {
		    		hasAccess =  true
		    	} else if (user.is_provider) {
		    		hasAccess =  true
		    	} 
		    	if (this.defaultPersonalManager && this.defaultPersonalManager.id == user.id) {
		    		hasAccess =  true
		    	}
	    	}
	    	return hasAccess
	    }
	},
	watch: {
		offerProgress: function(val) {
		    if (val < 0) {
			  this.offerProgress = 0
			} else if (val > 100) {
				this.offerProgress = val.substring(0, 2)
			}
	    },
		chatRoomApplyOfferObj (chatRoomApplyOfferObj) {
			if (chatRoomApplyOfferObj) {
				for (let i = 0; i < this.rooms.length; i++) {
					if (this.rooms[i].id == this.chatRoomApplyOfferObj.room_id) {
						const room = this.rooms[i]
						room.apply_offer = chatRoomApplyOfferObj.apply_offer
						Vue.set(this.rooms, i, room)
					}
				}
				this.activeRoom.apply_offer = chatRoomApplyOfferObj.apply_offer
			}
		},
		offerUser (offerUser) {
			this.$store.commit('setModal', {
		        template: 'chat-offer',
		        options: {
		          offerUser: offerUser.user
		        }
	        })
		},
		chatOffer (chatOffer) {
			axios.post(process.env.VUE_APP_BACKEND_API_URL + 'chat/offer/' + this.activeRoom.id, {
				id: chatOffer.id,
				type: chatOffer.type,
			})
		      .then(({ data }) => {
		      	this.activeRoom.offerable_id = data.offerable_id
		      	this.activeRoom.offerable_type = data.offerable_type
		      	this.activeRoom.offerable = data.offerable
		        for (let i = 0; i < this.rooms.length; i++) {
					if (this.rooms[i].id == this.activeRoom.id) {
				      	const room = this.rooms[i]
				      	room.offerable_id = data.offerable_id
				      	room.offerable_type = data.offerable_type
				      	room.offerable = data.offerable
						Vue.set(this.rooms, i, room)
					}
				} 
		      })
		      .catch((error) => console.log(error))
		},
		newChatRoom (newChatRoom) {
			if (newChatRoom) {
				newChatRoom = this.proccessServerRoom(newChatRoom)
				for (let i = 0; i < this.rooms.length; i++) {
					this.rooms[i].active = false
				}
				newChatRoom.active = true
				this.rooms.unshift(newChatRoom)
				this.selectRoom(newChatRoom.id)
			}
		},
	    newMessage (newMessage) {
	      if (newMessage) {
	      	let newMessageChatIndex = null
	      	for (let i = 0; i < this.rooms.length; i++) {
				if (this.rooms[i].id == newMessage.message.room_id) {
					newMessageChatIndex = i
					let noSameMessage = true
					this.rooms[i].messages.forEach(message => {
						if (message.id == newMessage.message.id) {
							if (newMessage.message.documents.length > 0) {
								message.documents.forEach(document => {
									if (newMessage.message.documents) {
										newMessage.message.documents.forEach(newDocument => {
											if (document.id == newDocument.id) {
												noSameMessage = false
											}
										})
									}
								})
							} else {
								noSameMessage = false
							}
							
						}
					})

					if (noSameMessage) {
						const message = newMessage.message
						message.user = {
							id: newMessage.sender_id,
							company_full_name: newMessage.sender_login,
							logo: newMessage.sender_logo,
						}
						this.rooms[i].messages.push(message)
						if (this.rooms[i].id != this.activeRoom.id) {
	                      this.rooms[i].unread_messages++
						} else {
							const that = this
							setTimeout(function () {
								that.setRoomMessagesRead(that.activeRoom.id)
								that.setCountRoomMessagesRead(that.activeRoom.id)
								that.decrementMessageCount()
								that.$refs.chatMessagesScrolls.osInstance().scroll({ y : "100%" }, 150)
							}, 700)
						}
					}
				}
			}

			this.rooms.sort(function(x,y){ return x.id == newMessage.message.room_id ? -1 : y.id == newMessage.message.room_id ? 1 : 0; });
	      }
	    }
	  }
}
</script>

<style type="text/css">
.no-messages {
	display: flex;
	align-items: center;
    justify-content: center;
    height: 100%;
}
.main-block {
	height: 80%;
	border-radius: 0.3125rem;
	margin-bottom: 24px;
} 
.contacts {
	padding: 0 0.5rem 0.5rem;
	//border-right: 2px solid rgba(9,9,11,.1);
}
.contacts + .col-9{
	background: #f1f1f1;
	border-radius: 0.3125rem;
}
.messages {
	margin: 0.5rem;
	padding: 1rem;
}
.row {
	display: flex;
    flex-direction: row;
}
.col-3 {
	width: 30%;
}
.col-9 {
	width: 70%;
}
.send-actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
	flex-wrap: wrap;
    width: 100%;
	gap: 8px;
}

textarea.main-message {
	width: 65%;
	padding: 10px;
	display: flex;
	align-items: center;
	gap: 4px;
	padding: 4px !important;
	position: relative;
	align-self: stretch;
	width: 100%;
	flex: 0 0 auto;
	border-radius: 5px;
	border: 1px solid;
	border-color: #ababb2;
	color: #09090b;
	margin-bottom: 0 !important;
	resize: none;
	width: 100%;
	flex: 1 1 100%;
	min-width: 100%;
}

.form-control {
    width: 100%;
    height: 100%;
    color: #ffffff;
    padding: 0.5rem;
    margin: auto 0rem;
    border: 1px solid #2F363D;
    border-radius: 0.5rem;
    outline: none;
    -webkit-appearance: none;
	flex: 0 0 auto;
	max-width: calc(100% - 5rem);
}
.send-btn {
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
	min-width: 2.5rem;
	height: 2.5rem;
    background: #1763fb;
    box-shadow: 0px 12px 23px rgb(62 73 84 / 4%);
    border-radius: 6px;
}

.upload-btn {
	min-width: 2.5rem;
	height: 2.5rem;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1763fb;
    box-shadow: 0px 12px 23px rgb(62 73 84 / 4%);
    border-radius: 6px;
}

.chat {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 10px;
  border-radius: 10px;
  cursor: pointer;
  background: #a9aabc;
}

.room-item{
	margin-bottom: 8px;
}

.message {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  background-color: #a9aabc;
  padding: 10px;
  border-radius: 10px
}

.chat .img {
	display: inline;
	margin-right: 20px;
}

.chat .img img {
	width: 50px;
	display: inline;
	border-radius: 10px;
}

.message .img {
	width: 30px;
	height: 30px;
	display: inline;
	margin-right: 20px;
}

.message .img img {
	width: 30px;
	height: 30px;
	display: inline;
	border-radius: 10px;
}
.room-active {
	background-color: #454655;
}
.message {
	margin-bottom: 15px;
}
.user-message {
	background-color: #454655;
	margin-left: 90px;
	padding: 10px;
	border-radius: 10px;
}

.send-btns {
	display: flex;
	flex-direction: column;
}

.preview-mode {
	margin: 1rem;
}

.preview-text {
	margin-left: 10px;
}

.chat-read {
	background-color: #303030;
}

.chat-content {
	display: flex;
	flex-direction: row;
}
.chat-content {
	display: flex;
	flex-direction: column;
}

.chat-name {
	margin-bottom: 5px;
}

.chat-subinfo {
	margin-top: 5px;
	font-size: 10px;
}

.chat-subinfo-count {
	border-radius: 20px;
	background-color: #1C2126;
	padding: 0.5rem;
}

.public-chat-name {
	font-size: 10px;
}

.room-has-name {
	font-size: 14px;
}

.message-content {
	display: flex;
	flex-direction: column;
}

.message-date {
	font-size: 8px;
}

.message-user-login {
	margin-bottom: 5px;
}

.message-text {
	margin-bottom: 5px;
}

.pre-formatted {
  white-space: break-spaces;
}

.files-input {
	display: none;
}

.document-link {
	color: #ffffff;
}

.add-chat-btn {
    height: 2.5rem;
	width: 2.5rem;
    font-size: 1rem;
	padding: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #1763fb;
    border-radius: 0.3125rem;
	flex: 1 0 auto;
}

.puls-btn {
  animation: btnPulse-2 2.5s infinite alternate ease-in-out;
}

@keyframes btnPulse-2 {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(1.05);
    background: #21b184;
  }
  50% {
    transform: scale(1);
    background: #8ad4bd;
  }
}

.menu-settings-img {
	width: 20px;
    height: 20px;
    cursor: pointer;
    margin-top: 1.1rem;
}

.actions {
	display: flex;
	flex-direction: row;
	margin-bottom: 8px;
}

.apply-offer-wrapper {
	padding: 1rem;
	background-color: #535F6B;
}

.col-6 {
	width: 50%;
}

.offer-desc-input {
	margin: 0.5rem 0;
}

.save-offer-desc-btn {
	width: 4rem;
    height: 2rem;
    margin: 0.5rem;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 6px;
}

.offer-progress-info {
	position: relative;
}

.edit-offer-desc-btn {
	position: absolute;
	right: 0px;
	top: -10px;
	width: 4rem;
    height: 2rem;
    margin: 0.5rem;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    box-shadow: 0px 12px 23px rgb(62 73 84 / 4%);
	color: #fff !important;
    border-radius: 6px;
}

.select-offer-desc-btn {
	width: 12rem;
    height: 2rem;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
	background: #fff;
    border-radius: 6px;
	color: #fff;
}

.cancel-offer-desc-btn {
	width: 8rem;
    height: 2rem;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-radius: 6px;
	color: #fff;
    box-shadow: 0px 12px 23px rgb(62 73 84 / 4%);
}

.edit-offer-desc-btn svg.img {
    width: 1rem;
    height: 1rem;
}

.select-offer-action-btns {
	display: flex;
	flex-direction: row;
}

.offer-main-info {
	position: relative;
}

.edit-offer-btn {
	width: 4rem;
    height: 2rem;
    margin: 0.5rem 0;
    font-size: 1.25rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
	color: #fff;
    box-shadow: 0px 12px 23px rgb(62 73 84 / 4%);
    border-radius: 6px;
}

.edit-offer-btn svg.img {
    width: 1rem;
    height: 1rem;
}


.chat-role {
	font-size: 8px;
	margin-bottom: 5px;
}
</style>